// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d480e6c","431":"6eb59660","455":"6007a5c6"}[chunkId] + ".chunk.js";
};